import RecordEventsEdit from '@/components/ezuro/workschedule/components/edit/RecordEventsEdit.vue';

export default {
  name: 'Events',
  props: {
    recordID: {
      type: Number
    },
    events: {
      type: Array
    },
    basePath: {
      type: String,
      default: 'ezuro/schedule/row/event'
    },
    scheduleData: {
      type: Object
    },
    scheduleId: {
      type: Number
    }
  },
  components: {
    RecordEventsEdit
  },
  data () {
    return {
      isLoading: false
    }
  },
  computed: {
    tableHeaders () {
      const headers = [
        { key: 'event_id', label: this.$t('work-schedule.event'), sortable: false, filterKey: 'event', format: 'formatFunc', funcs: [this.getEventName] },
        { key: 'minutes', label: this.$t('work-schedule.minutes') },
        { key: 'notes', label: this.$t('work-schedule.notes') }
      ];

      if (this.canEdit) {
        const actions = [
          { label: this.$t('general.actions.edit'), emit: 'editItem', bicon: 'pencil-fill', class: 'btn-sm btn-primary' },
          { label: this.$t('general.actions.delete'), emit: 'deleteItem', bicon: 'trash', class: 'btn-sm btn-danger', ifconfig: { param: 'deleted_at', value: null } }
        ];
        headers.push({ key: 'actions', label: '', actions, classTd: 'w-15' });
      }

      return headers;
    },
    tableActions () {
      const actions = { download: false };
      if (this.canEdit) {
        actions.add = { title: this.$t('general.actions.add') };
      }
      return actions;
    },
    eventOptions () {
      const path = 'ezuro/events/list?perPage=10000';
      const events = [];
      this.isLoading = true;
      this.ApiRequest.request(path, this.ApiRequest.REQUEST_GET, {}, (response) => {
        if (response.data) {
          for (const key in response.data) {
            events.push({ value: response.data[key].id, text: response.data[key].name });
          }
          this.isLoading = false;
        }
      });

      return events;
    },
    canEdit () {
      let isConfirmed = false;
      for (const key in this.scheduleData.schedules) {
        if (this.scheduleData.schedules[key].id == this.scheduleId) {
          isConfirmed = this.scheduleData.schedules[key].status === 'confirmed';
        }
      }
      return !this.isLoading && !isConfirmed;
    }
  },
  methods: {
    getEventName (id) {
      if (id) {
        for (const key in this.eventOptions) {
          if (this.eventOptions[key].value == id) {
            return this.eventOptions[key].text;
          }
        }
      }

      return null;
    },
    loadEvents () {
      this.$emit('reload');
    },
    addItem () {
      this.editItem({
        id: null,
        schedule_row_id: this.recordID,
        event_id: null,
        minutes: 0,
        notes: ''
      });
    },
    editItem (el) {
      this.$refs.editEventsRecord.show(el);
    },
    deleteItem (el, approved) {
      if (approved) {
        this.isLoading = true;
        this.ApiRequest.request(this.basePath + '/destroy/' + el.id, this.ApiRequest.REQUEST_GET, {}, (response) => {
          if (response.error) {
            this.ApiRequest.displayErrorDialog(response, this);
          } else {
            this.loadEvents();
          }
          this.isLoading = false;
        });
      } else {
        this.$refs.itemDeleteMsgBox.show(el, this.$t('general.item.deleteTitle'));
      }
    }
  }
}
